module.exports = __webpack_public_path__ + "static/media/icon-swiss-knife.8037b1d6.svg";